module.exports = __webpack_public_path__ + "5b7c860039ea61e61c84c2e31b2dccde.pdf";